var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spinner-until',{attrs:{"condition":_vm.surveyId != null}},[_c('div',{staticClass:"survey-create"},[(_vm.surveyId)?_c('survey-form',{attrs:{"survey-id":_vm.surveyId}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }